import React, { FC, ReactElement } from 'react';

import TooltipWhite from 'buyside/components/presentation/Tooltips/TooltipWhite/tooltipWhite';
import AcceptModal from 'buyside/components/presentation/JobApplicationShowPage/JobApplicationShowModal/ModalParts/AcceptModal';
import RejectModal from 'buyside/components/presentation/JobApplicationShowPage/JobApplicationShowModal/ModalParts/RejectModal';
import {
  HandleMutations,
  JobApplication
} from 'buyside/components/container/JobApplicationShowPage/jobApplicationShowPageMutationsContainer';

import { userUrl } from 'buyside/util/urlHelper';

import Icon from 'buyside/components/presentation/Icon/icon';
import PDFIcon from 'buyside/svgs/document/file-pdf.svg';
import star from 'buyside/svgs/star.svg';
import thumbsUp from 'buyside/svgs/thumbs_up.svg';
import thumbsDown from 'buyside/svgs/thumbs_down.svg';

const { jobApplicationStatuses } = require('buyside/util/constantsFromRails.json');

import styles from './JobApplicationShowCardStyles.scss';

const JobApplicationShowCard: FC<Pick<
  JobApplication,
  'coverNote' | 'email' | 'name' | 'phone' | 'resumeUrl' | 'starred' | 'status' | 'userId'
> & {
  handleInterviewed: HandleMutations['handleInterviewed'];
  handleRejected: HandleMutations['handleRejected'];
  handleStarred: HandleMutations['handleStarred'];
}> = ({
  coverNote,
  email,
  handleInterviewed,
  handleRejected,
  handleStarred,
  name,
  phone,
  resumeUrl,
  starred,
  status,
  userId
}): ReactElement => {
  return (
    <div className={`${styles.cardContainer} ${styles.container}`}>
      <div className={styles.header}>
        <div className={styles.left}>
          <TooltipWhite overlay={<div>Bookmark this applicant</div>} placement="top">
            <span data-testid="appStar" data-test="starIcon" onClick={(): void => handleStarred()}>
              <Icon type={star} className={starred ? styles.starred : styles.unstarred} />
            </span>
          </TooltipWhite>
          <div className={styles.name}>{name}</div>
        </div>

        <div className={styles.right}>
          {status !== jobApplicationStatuses.rejected &&
          status !== jobApplicationStatuses.interviewed_and_rejected ? (
            <>
              {status !== jobApplicationStatuses.interviewed && (
                <AcceptModal
                  name={name}
                  handleSubmit={handleInterviewed}
                  renderOpenButton={(openModal): ReactElement => (
                    <div data-test="acceptIcon" onClick={openModal}>
                      <Icon type={thumbsUp} className={styles.thumbsUp} />
                    </div>
                  )}
                />
              )}

              <RejectModal
                name={name}
                handleSubmit={handleRejected}
                renderOpenButton={(openModal): ReactElement => (
                  <div data-test="rejectIcon" onClick={openModal}>
                    <Icon type={thumbsDown} className={styles.thumbsDown} />
                  </div>
                )}
              />
            </>
          ) : (
            <div>Rejected</div>
          )}
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.label}>Resume</div>
        <a
          className={styles.link}
          href={resumeUrl || undefined}
          target="_blank"
          rel="noopener noreferrer"
        >
          <PDFIcon className={styles.pdfIcon} /> View {name}'s resume
        </a>
      </div>

      <div className={styles.section}>
        <div className={styles.label}>Phone</div>
        <div>{phone}</div>
      </div>

      <div className={styles.section}>
        <div className={styles.label}>Email</div>
        <div>{email}</div>
      </div>

      {coverNote ? (
        <div className={styles.section}>
          <div className={styles.label}>Cover Letter</div>
          <div>{coverNote}</div>
        </div>
      ) : null}

      <div className={styles.section}>
        <a className={styles.link} href={userUrl(userId)}>
          View {name}'s Private Profile
        </a>
      </div>
    </div>
  );
};

export default JobApplicationShowCard;
